
import { useModalesStore } from "../../../store";







export const useModales = () => {


    const { changeEstadoModalUno } = useModalesStore(); 
        

    const handleAbrilModal = () => {
        changeEstadoModalUno(true);
    }

    const handleCerrarModal = () => {
        changeEstadoModalUno(false);
    }


    return {
        handleAbrilModal,
        handleCerrarModal,
    }
}
